function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import { UncontrolledSlider } from "./UncontrolledSlider";
import "./slider.css";
// Props:
//  - classPrepend: (string) The class to prepend to the component's className
//  - value: (number | number[]) The value of the slider. For ranged sliders, pass an array of two numbers.
//  - onChange: (function) The function to call when the slider value changes. It should take an event object and a value as arguments.
//  - rest: (object) The rest of the props to pass to the component. current contains the value prop for controlled tabs
//  - rest may include:
//  - defaultValue: (number | number[]) The default value of the slider. For ranged sliders, pass an array of two numbers. this is used for uncontrolled sliders
//  - disabled: (boolean) If true, the slider will be disabled.
//  - min: (number) The minimum allowed value of the slider.
//  - max: (number) The maximum allowed value of the slider.
//  - step: (number) The granularity with which the slider can step through values. (A "discrete" slider.)If the user should only be able to select from the values provided with the marks prop, add step={null} to disable all other options:
//  - marks: (boolean | array) If true, the slider will be displayed as a range slider. If an array, it should contain objects with value and an optional label keys.
//  - slots: (object) The slots for the slider. This is used to customize the slider.
//  - getAriaValueText: (function) A function that formats the slider's value to a string to be read by screen readers. It should take a value as an argument and return a string.
//  - aria-label: (string) The aria-label attribute of the slider.

const ControlledSlider = ({
  classPrepend = "styled",
  ariaLabel = "slider",
  value = null,
  onChange = null,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(UncontrolledSlider, _extends({
    classPrepend: classPrepend,
    ariaLabel: ariaLabel,
    value: value,
    onChange: onChange
  }, rest));
};
export { ControlledSlider };